import { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';

import { GridColDef } from '@mui/x-data-grid-pro';

const useColumnDefinitions = () => {
  const { t } = useTranslation();

  return generateColumns(t);
};

const generateColumns = (t: TFunction): GridColDef[] => [
  {
    field: 'code',
    headerName: t('surchargesMaintenance.grid.code'),
    type: 'string',
    hideable: false,
    minWidth: 100,
    flex: 1
  },
  {
    field: 'name',
    headerName: t('surchargesMaintenance.grid.name'),
    type: 'string',
    minWidth: 150,
    flex: 2
  }
];

export default useColumnDefinitions;
